<div class="flex relative flex-col w-full space-y-1">
  @if (showLabel) {
  <label class="text-[16px]" [for]="id">{{ label }}</label>
  } @if (issCurrency) {
  <input
    [type]="type"
    class="appearance-none border rounded w-full h-[45px] py-2 px-3 text-gray-700 mb-1 leading-tight focus:outline-none focus:shadow-outline"
    [id]="id"
    [placeholder]="placeholder"
    [readOnly]="disabled"
    [formControl]="control"
    [class.invalid]="control.invalid && (control.dirty || control.touched)"
    [class.bg-gray-200]="disabled"
    appAddCommas
    (keypress)="numberOnly($event)"
  />
  } @else {
  <input
    [type]="type"
    class="appearance-none border rounded w-full h-[45px] py-2 px-3 text-gray-700 mb-1 leading-tight focus:outline-none focus:shadow-outline"
    [id]="id"
    [placeholder]="placeholder"
    [attr.placeholder]="type !== 'file' ? placeholder : null"
    [readOnly]="disabled"
    [formControl]="control"
    [class.invalid]="control.invalid && (control.dirty || control.touched)"
    [class.bg-gray-200]="disabled"
    (change)="type == 'file' ? onSelectedFile($event) : ''"
    accept=".jpeg,.jpg,.png, .gif"
  />
  } @if (control.invalid && (control.dirty || control.touched)) { @for (err of
  control.errors | keyvalue; track $index) {
  <div
    class="text-red-500 absolute bottom-[-22px] flex items-center text-[12px]"
  >
    @if (errorMessages[err.key]) {
    <i class="material-icons text-[15px]">error</i>
    <a>{{ errorMessages[err.key] }}</a>
    }
  </div>
  } } @if (showPasswordEye) {
  <div (click)="setPasswordVibility()" class="absolute cursor-pointer z-30 top-[30px] right-3">
    @if (passwordVibility) {
    <i class="material-icons">visibility_off</i>
    } @else {
    <i class="material-icons">visibility</i>
    }
  </div>
  }
</div>
